import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/Sun.svg'
import _imports_1 from '@/assets/arrow-left.svg'
import _imports_2 from '@/assets/arrow-right.svg'
import _imports_3 from '@/assets/return-arrow.svg'
import _imports_4 from '@/assets/Calendar_Week.svg'
import _imports_5 from '@/assets/File_Check.svg'
import _imports_6 from '@/assets/Clipboard_Check.svg'
import _imports_7 from '@/assets/search-redesign.svg'
import _imports_8 from '@/assets/filter-redesign.svg'
import _imports_9 from '@/assets/refresh-redesign.svg'


const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex gap-3" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "font-normal text-primary-text-color text-sm max-[910px]:text-[14px]" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center gap-[6px] py-[6px] px-2 rounded-[7px] bg-white"
}
const _hoisted_7 = { class: "font-normal text-primary-text-color text-sm max-[910px]:text-[14px]" }
const _hoisted_8 = {
  key: 1,
  class: "text-sm flex items-center gap-[6px] py-[6px] px-2 rounded-[7px] bg-white"
}
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "font-normal text-primary-text-color text-sm max-[910px]:text-[14px]" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "flex items-center gap-[6px] py-[6px] px-2 rounded-[7px] bg-white"
}
const _hoisted_13 = { class: "font-normal text-primary-text-color text-sm max-[910px]:text-[14px]" }
const _hoisted_14 = {
  key: 1,
  class: "text-sm flex items-center gap-[6px] py-[6px] px-2 rounded-[7px] bg-white"
}
const _hoisted_15 = { class: "font-normal text-primary-text-color text-sm max-[910px]:text-[14px]" }
const _hoisted_16 = { class: "font-normal text-primary-text-color text-sm max-[910px]:text-[14px]" }
const _hoisted_17 = { class: "flex items-center gap-3" }
const _hoisted_18 = ["placeholder", "value"]
const _hoisted_19 = { class: "flex items-center gap-2" }
const _hoisted_20 = {
  key: 0,
  class: "absolute top-1 right-1 bg-[#393840] text-white text-[10px] font-bold rounded-[36px] w-[16px] h-[16px] px-[4px] py-[1px] flex items-center justify-center"
}

import PageHeader from "../PageHeader/PageHeader.vue";

import { ref } from "vue";
import { useTranslate } from "@/composables/useTranslate";

type Props = {
  isTodayNavigationActive: boolean;
  todayDatePicker: boolean;
  isWeekNavigationActive: boolean;
  weekDatePicker: boolean;
  selectedDate: Date;
  selectedStartDate: Date;
  selectedEndDate: Date;
  activeFilter: string;
  searchQuery: string;
  isLoading: boolean;
  activeViewList: any;
  activeStatusList: any;
  activeNamesList: any;
  isFilterOpen: any;
};

type Emits = {
  (event: "goToPreviousDay"): void;
  (event: "goToNextDay"): void;
  (event: "resetToToday"): void;
  (event: "goToPreviousWeek"): void;
  (event: "goToNextWeek"): void;
  (event: "resetToThisWeek"): void;
  (event: "getAllProjects"): void;
  (event: "toggleFilterMenu"): void;
  (event: "setActiveFilter", filter: string): void;
  (event: "onChangeSearch", searchQuery: string): void;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'MainPageHeader',
  props: {
    isTodayNavigationActive: { type: Boolean },
    todayDatePicker: { type: Boolean },
    isWeekNavigationActive: { type: Boolean },
    weekDatePicker: { type: Boolean },
    selectedDate: {},
    selectedStartDate: {},
    selectedEndDate: {},
    activeFilter: {},
    searchQuery: {},
    isLoading: { type: Boolean },
    activeViewList: {},
    activeStatusList: {},
    activeNamesList: {},
    isFilterOpen: {}
  },
  emits: ["goToPreviousDay", "goToNextDay", "resetToToday", "goToPreviousWeek", "goToNextWeek", "resetToThisWeek", "getAllProjects", "toggleFilterMenu", "setActiveFilter", "onChangeSearch"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const { t } = useTranslate();
const isSearchFocused = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageHeader, null, {
    "header-left": _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (!__props.isTodayNavigationActive)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('setActiveFilter', 'today'))),
                    id: "today",
                    class: "flex gap-1 items-center p-2 cursor-pointer bg-transparent rounded-md hover:bg-[#d3d1cd] duration-300"
                  }, [
                    _cache[23] || (_cache[23] = _createElementVNode("img", {
                      src: _imports_0,
                      alt: "Sun icon"
                    }, null, -1)),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("home.today")), 1)
                  ]))
                : _createCommentVNode("", true),
              (__props.isTodayNavigationActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (!__props.todayDatePicker)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("span", {
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('goToPreviousDay')), ["stop"])),
                            class: "cursor-pointer w-4 h-4 flex items-center justify-center"
                          }, [...(_cache[24] || (_cache[24] = [
                            _createElementVNode("img", {
                              src: _imports_1,
                              alt: "Return arrow"
                            }, null, -1)
                          ]))]),
                          _createElementVNode("button", {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('setActiveFilter', 'today')))
                          }, [
                            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("home.today")), 1)
                          ]),
                          _createElementVNode("span", {
                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('goToNextDay')), ["stop"])),
                            class: "cursor-pointer w-4 h-4 flex items-center justify-center"
                          }, [...(_cache[25] || (_cache[25] = [
                            _createElementVNode("img", {
                              src: _imports_2,
                              alt: "Return arrow"
                            }, null, -1)
                          ]))])
                        ]))
                      : _createCommentVNode("", true),
                    (__props.todayDatePicker)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("button", {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('resetToToday'))),
                            class: "w-3 h-3 rounded"
                          }, [...(_cache[26] || (_cache[26] = [
                            _createElementVNode("img", {
                              src: _imports_3,
                              alt: "Return arrow"
                            }, null, -1)
                          ]))]),
                          _createElementVNode("button", {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('setActiveFilter', 'today'))),
                            id: "today",
                            class: "flex cursor-pointer font-normal text-sm max-[910px]:text-[10px]"
                          }, [
                            _createElementVNode("span", null, _toDisplayString(__props.selectedDate.toLocaleDateString("en-US", {
                          month: "long",
                          day: "numeric",
                        })), 1)
                          ]),
                          _createElementVNode("span", {
                            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.$emit('goToPreviousDay')), ["stop"])),
                            class: "cursor-pointer w-4 h-4 flex items-center justify-center"
                          }, [...(_cache[27] || (_cache[27] = [
                            _createElementVNode("img", {
                              src: _imports_1,
                              alt: "Return arrow"
                            }, null, -1)
                          ]))]),
                          _createElementVNode("span", {
                            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.$emit('goToNextDay')), ["stop"])),
                            class: "cursor-pointer w-4 h-4 flex items-center justify-center"
                          }, [...(_cache[28] || (_cache[28] = [
                            _createElementVNode("img", {
                              src: _imports_2,
                              alt: "Return arrow"
                            }, null, -1)
                          ]))])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (!__props.isWeekNavigationActive)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('setActiveFilter', 'week'))),
                    id: "week",
                    class: "flex gap-1 items-center p-2 cursor-pointer bg-transparent rounded-md hover:bg-[#d3d1cd] duration-300"
                  }, [
                    _cache[29] || (_cache[29] = _createElementVNode("img", {
                      src: _imports_4,
                      alt: "Sun icon"
                    }, null, -1)),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)("home.this_week")), 1)
                  ]))
                : _createCommentVNode("", true),
              (__props.isWeekNavigationActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (!__props.weekDatePicker)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("span", {
                            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.$emit('goToPreviousWeek')), ["stop"])),
                            class: "cursor-pointer w-4 h-4 flex items-center justify-center"
                          }, [...(_cache[30] || (_cache[30] = [
                            _createElementVNode("img", {
                              src: _imports_1,
                              alt: "Return arrow"
                            }, null, -1)
                          ]))]),
                          _createElementVNode("button", {
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('setActiveFilter', 'week')))
                          }, [
                            _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)("home.this_week")), 1)
                          ]),
                          _createElementVNode("span", {
                            onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.$emit('goToNextWeek')), ["stop"])),
                            class: "cursor-pointer w-4 h-4 flex items-center justify-center"
                          }, [...(_cache[31] || (_cache[31] = [
                            _createElementVNode("img", {
                              src: _imports_2,
                              alt: "Return arrow"
                            }, null, -1)
                          ]))])
                        ]))
                      : _createCommentVNode("", true),
                    (__props.weekDatePicker)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("button", {
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('resetToThisWeek'))),
                            class: "w-3 h-3 rounded"
                          }, [...(_cache[32] || (_cache[32] = [
                            _createElementVNode("img", {
                              src: _imports_3,
                              alt: "Return arrow"
                            }, null, -1)
                          ]))]),
                          _createElementVNode("button", {
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('setActiveFilter', 'week'))),
                            id: "week",
                            class: "flex cursor-pointer font-normal text-sm max-[910px]:text-[10px]"
                          }, [
                            _createElementVNode("span", null, _toDisplayString(__props.selectedStartDate.toLocaleDateString("en-US", {
                          month: "long",
                          day: "numeric",
                        })) + " - " + _toDisplayString(__props.selectedEndDate.toLocaleDateString("en-US", {
                          month: "long",
                          day: "numeric",
                        })), 1)
                          ]),
                          _createElementVNode("span", {
                            onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.$emit('goToPreviousWeek')), ["stop"])),
                            class: "cursor-pointer w-4 h-4 flex items-center justify-center"
                          }, [...(_cache[33] || (_cache[33] = [
                            _createElementVNode("img", {
                              src: _imports_1,
                              alt: "Return arrow"
                            }, null, -1)
                          ]))]),
                          _createElementVNode("span", {
                            onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.$emit('goToNextWeek')), ["stop"])),
                            class: "cursor-pointer w-4 h-4 flex items-center justify-center"
                          }, [...(_cache[34] || (_cache[34] = [
                            _createElementVNode("img", {
                              src: _imports_2,
                              alt: "Return arrow"
                            }, null, -1)
                          ]))])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('setActiveFilter', 'abnahme'))),
              id: "abnahme",
              class: _normalizeClass(["flex gap-1 items-center p-2 cursor-pointer rounded-md hover:bg-[#d3d1cd] duration-300", 
                __props.activeFilter === 'abnahme' ? 'bg-white' : 'bg-transparent'
              ])
            }, [
              _cache[35] || (_cache[35] = _createElementVNode("img", {
                src: _imports_5,
                alt: "Sun icon"
              }, null, -1)),
              _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)("home.abnahme_ready")), 1)
            ], 2),
            _createElementVNode("button", {
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('setActiveFilter', 'qc'))),
              id: "qc",
              class: _normalizeClass(["flex gap-1 items-center p-2 cursor-pointer rounded-md hover:bg-[#d3d1cd] duration-300", __props.activeFilter === 'qc' ? 'bg-white' : 'bg-transparent'])
            }, [
              _cache[36] || (_cache[36] = _createElementVNode("img", {
                src: _imports_6,
                alt: "Sun icon"
              }, null, -1)),
              _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(t)("home.qc_ready")), 1)
            ], 2)
          ])
        ])
      ])
    ]),
    "header-right": _withCtx(() => [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("form", {
          class: _normalizeClass(["max-w-[160px] max-[940px]:max-w-[84px] h-[30px] rounded-primary-radius px-[10px] border border-[#A7A5AE] bg-transparent flex items-center gap-1", `${isSearchFocused.value ? 'bg-white ' : ''}`])
        }, [
          _cache[37] || (_cache[37] = _createElementVNode("div", null, [
            _createElementVNode("img", {
              class: "w-4 h-4",
              src: _imports_7,
              alt: "Search"
            })
          ], -1)),
          _createElementVNode("input", {
            class: "w-full bg-transparent outline-none text-sm font-normal text-[#898790] placeholder:text-[#898790]",
            type: "text",
            placeholder: 
              isSearchFocused.value
                ? _unref(t)('home.project_name').value
                : _unref(t)('home.search').value
            ,
            value: __props.searchQuery,
            onInput: _cache[18] || (_cache[18] = (event)=>_ctx.$emit('onChangeSearch',event.target.value)),
            onFocus: _cache[19] || (_cache[19] = ($event: any) => (isSearchFocused.value = true)),
            onBlur: _cache[20] || (_cache[20] = ($event: any) => (isSearchFocused.value = false))
          }, null, 40, _hoisted_18)
        ], 2),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", {
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$emit('toggleFilterMenu'))),
            class: _normalizeClass(["relative flex items-center justify-center cursor-pointer hover:bg-white rounded-[7px] hover:shadow-[-4px_2px_4px_rgba(0,0,0,0.06)]", __props.isFilterOpen === true ? 'bg-white' : 'bg-transparent']),
            style: {"width":"40px","height":"40px"}
          }, [
            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "w-[24px] h-[24px] rounded-[7px] flex items-center justify-center" }, [
              _createElementVNode("img", {
                src: _imports_8,
                alt: "Filter",
                class: "w-5 h-5"
              })
            ], -1)),
            (
                __props.activeViewList.length +
                  __props.activeStatusList.length +
                  __props.activeNamesList.length >
                0
              )
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(__props.activeViewList.length +
                __props.activeStatusList.length +
                __props.activeNamesList.length), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("button", {
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('getAllProjects'))),
            class: _normalizeClass(["flex items-center justify-center cursor-pointer rounded-[7px] hover:bg-white hover:shadow-[-4px_2px_4px_rgba(0,0,0,0.06)] p-2", __props.isLoading ? 'bg-white ' : ''])
          }, [
            _createElementVNode("img", {
              class: _normalizeClass(__props.isLoading ? 'animate-spin' : 'animate-none'),
              src: _imports_9,
              alt: "Refresh"
            }, null, 2)
          ], 2)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})